import React, {useState}from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/blog.css';
import {FaBars, FaArrowRight} from "react-icons/fa";


const Blog = () => {
    const [open, setOpen] = useState(false);
    const style ={
        color:'#5cb85c',
        fontWeight:'bold',
    }
    return (
        <div className="">
            <nav>
                <div className="logo">fm</div>
                <ul className="nav-links" style={{ transform: open ? "translateX(0px)" : "" }}>
                    <li><Link className="nav-item" to="/">About</Link></li>
                    <li><Link className="nav-item" to="/" >Services</Link></li>
                    <li><Link className="nav-item" to="/projects">Projects</Link></li>
                    <li><Link className="nav-item" to="/">Skills</Link></li>
                    <li><Link className="nav-item" to='/' >Mentors</Link></li>
                    <li><Link className="nav-item" to="/blog">Blog</Link></li>
                    <li><Link className="nav-item" to="/contact">Contact</Link></li>
                </ul>
                <FaBars onClick={() => setOpen(!open)} className="fa-bars" color="#5cb85c" />
            </nav>
            <section className="section section-contact-us mb-0 pt-0 pt-sm-5 pb-3 pb-sm-3">
                <div className="container">
                    <div className="row justify-content-start" id="articles">
                        <div className="col-xl-12 col-12">
                        <h1 className="display-3 font-800 text-left pb-4">Articles and Publications</h1>
                        </div>
                        <div className="col-xl-7">
                            <div className="image-container image-featured">
                                <img alt="" id="image1"
                                src="images/articles/nodejs.png" width="100%" height="450px"/>
                            </div>
                            <div className="blog-info-section">
                                <h5 className="blog-info-title font-700 my-3">Getting Started with building a Location-Based(GIS) Restful API
                               with Nodejs, Postgresql and Express</h5>
                                <p className="blog-info-intro lead text-muted"> We will build a GIS REST API for mainly two datasets i.e. Nairobi Health Facilities and Nairobi Sub Counties. Add-ons will be 
                                GIS abilities to query the nearest health facilities when given a user location... 
                                <a href="https://fmuchembi.medium.com/getting-started-building-location-based-gis-rest-apis-with-nodejs-e4592b461994" style={style}>Read more</a>
                               </p>
                            </div>
                        </div>
                        <div className="col-xl-5 col-sm-12 col-12">
                            <div
                                className="blog-side-card d-flex justify-content-start align-content-center mb-3">
                                <div className="blog-side-card-img">

                                    <img alt=""
                                        src="images/articles/groundwater.png"/>
                               </div>
                                <div className="blog-side-card-info pl-1">
                                   <h5 className="display-4 mb-0">Groundwater potential zonation ...</h5>
                                   <p className="text-muted lead mt-0"> To demonstrate how GIS can help identify ground water potential 
                                    zones in ASAL areas to enable introduction of
                                    alternative economic activities...
                                   <a href="https://drive.google.com/file/d/1nrtC8rMccW2cZsx2mz1GKviXR4ez46qN/view?usp=sharing" style={style}>Read more</a>
                                   </p>
                                </div>
                        </div>
                        <div className="blog-side-card d-flex justify-content-start align-content-center mb-3">
                            <div className="blog-side-card-img">
                                <img alt="" src="images/articles/react-leaflet.png" 
                               />

                                </div>
                            <div className="blog-side-card-info pl-1">
                                <h5 className="display-4 mb-0">Consuming a Geospatial REST API with React-leaflet</h5>
                                    <p className="text-muted lead mt-0"> In this article we shall build a web application with leaflet web maps that consumes the REST API we build in our previous article 
                                    Getting Started: Building... <a href="https://drive.google.com/file/d/1nrtC8rMccW2cZsx2mz1GKviXR4ez46qN/view?usp=sharing" style={style}>Read more</a> </p>
                            </div>
                        </div>
                        <div
                            className="blog-side-card d-flex justify-content-start align-content-center mb-3">
                            <div className="blog-side-card-img"><img  alt=""
                                src="images/articles/jwt.png" />
                            </div>
                            <div className="blog-side-card-info pl-1">
                                <h5 className="display-4 mb-0">Produced maps in pdf format</h5>
                                <p className="text-muted lead mt-0"> Here is a document of my produced maps, in pdf format, the maps are of various projects, the buiding tools include
                                ArcGIS, QGIS and Adobe Photoshop... <a href="https://drive.google.com/file/d/1bWr2VssO0s7ZM9gKIbkSLrnO7JBBw1A3/view?usp=sharing" style={style}>Read more</a> </p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
        </section>
        <section className="gallery">
            <div className="container" id="gallery">
                <h1>Gallery</h1>
                <div className="row">
                    <div className="col-lg-4 col-md-12 mb-4">
                       <img src="images/Gallery/5.png" className="img-fluid mb-4" alt=""/>
                       <img src="images/Gallery/0.png" className="img-fluid mb-4" alt=""
                        data-wow-delay="0.3s"/>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-4">
                        <img src="images/Gallery/3.png" className="img-fluid mb-4" alt="" data-wow-delay="0.1s"/>
                        <img src="images/Gallery/2.png" className="img-fluid mb-4" alt="" data-wow-delay="0.4s"/>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-4">
                        <img src="images/Gallery/6.png" className="img-fluid mb-4" alt=""
                            data-wow-delay="0.2s"/>
                        <img src="images/Gallery/8.png" className="img-fluid mb-4" alt=""
                            data-wow-delay="0.5s"/>
                    </div>
                </div>
                 <div className="row">
                    <div className="col-lg-4 col-md-12 mb-4">
                       <img src="images/Gallery/12.jpg" className="img-fluid mb-4" alt=""/>
                       <img src="images/Gallery/14.jpg" className="img-fluid mb-4" alt=""
                        data-wow-delay="0.3s"/>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-4">
                        <img src="images/Gallery/13.jpg" className="img-fluid mb-4" alt="" data-wow-delay="0.1s"/>
                        <img src="images/Gallery/15.jpg" className="img-fluid mb-4" alt="" data-wow-delay="0.4s"/>
                    </div>
                    <div className="col-lg-4 col-md-6 mb-4">
                        <img src="images/Gallery/11.jpg" className="img-fluid mb-4" alt=""
                            data-wow-delay="0.2s"/>
                        <img src="images/Gallery/10.jpg" className="img-fluid mb-4" alt=""
                            data-wow-delay="0.5s"/>
                    </div>
                </div>
             </div>       
        </section>
        <section>
            <div className="bt-container">
                <div className="green-shadow">
                    <h1 id="h1-bt">Get in touch</h1>
                    <div className='row' id="row-bt">
                            <div className="col-sm" id="bottom_buttons">
                            <button type="button" className="btn btn-success btn-lg">
                                <Link className="bt_link" to="/contact">Reach out to me today</Link></button>
                            <div id ="gif">
                                <img src="./images/gif/giphy.gif" width="150" height="150" />
                            </div>
                        </div>
                        <div className="col-sm" id="bottom_buttons">
                            <button type="button" className="btn btn-success btn-lg">Lets build awesome projects together</button>
                        </div>
                    </div>
                </div>
            </div>  
        </section>
        <section>
            <div className="footer-section">
                <div className='footer-row'>
                    <div className="row">
                        <div className="col-sm" id="footer-col-sm">
                            <h4>My main goal</h4>
                            <li><a className="">
                                My main goal is to Intergrate <br /> existing GIS capabilities to <br />applications and solutions in<br /> various companies</a>
                            </li>
                        </div>
                        <div className="col-sm" id="footer-col-sm">
                            <h4>Links</h4>
                            <ul className="list-unstyled">
                                <li> <FaArrowRight /><a href="#about" className="">About</a></li>
                                <li> <FaArrowRight /><a href="#resume" className="">Resume</a></li>
                                <li> <FaArrowRight /><a href="#service" className="">Services</a></li>
                                <li> <FaArrowRight /><a href="#skills" className="">Skills</a></li>
                                <li> <FaArrowRight /><a href="#projects" className="">Projects</a></li>
                                <li> <FaArrowRight /><a href="#mentor" className="">Mentors</a></li>
                                <li> <FaArrowRight /><a href="#contacts" className="">Contacts</a></li>
                                <li> <FaArrowRight /><a href="#blog" className="">Blog</a></li>
                            </ul>
                        </div>
                        <div className="col-sm" id="footer-col-sm">
                            <h4 className="">Skills</h4>
                            <ul className="list-unstyled">
                                <li><FaArrowRight /><a href="#" className="">ReactJS</a></li>
                                <li><FaArrowRight /><a href="#" className="">NodeJS</a></li>
                                <li><FaArrowRight /><a href="#" className="">Django</a></li>
                                <li><FaArrowRight /><a href="#" className="">Web Development</a></li>
                                <li><FaArrowRight /><a href="#" className="">GIS analysis</a></li>
                                <li><FaArrowRight /><a href="#" className="">Python</a></li>
                                <li><FaArrowRight /><a href="#" className="">Remote Sensing</a></li>
                                <li><FaArrowRight /><a href="#" className="">Postgresql</a></li>
                            </ul>
                        </div>
                        <div className="col-sm" id="footer-col-sm" >
                            <h4>Social platforms</h4>
                            <li><a>You can also find me on these social media platforms</a></li>
                            <ul className="list-unstyled" id="list-one">
                                <li id="icons1"><a href="https://www.linkedin.com/in/faith-muchembi-71b53910b" target="_blank"><span className="fa fa-linkedin" id="the-fa"></span></a></li>
                                <li id="icons2"><a href="https://github.com/fmuchembi" target="_blank"><span className="fa fa-github" id="the-fa1" ></span></a></li>
                                <li id="icons3"><a href="https://web.facebook.com/fmuchembi" target="_blank"><span className="fa fa-facebook" id="the-fa2"></span></a></li>
                                <li id="icons5"><a href="https://twitter.com/muchembif" target="_blank"><span className="fa fa-twitter" id="the-fa4"></span></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="footer-section-2">
            <div className='footer-row2'>
                <div className="row">
                    <div className="col-md-12 text-center">
                        <p>Copyright &copy; <script>document.write(new Date().getFullYear());</script> Designed and built by Faith Muchembi</p>
                    </div>
                </div>
            </div>
        </section>
    </div>

    );
}



export default Blog;